import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable, ReplaySubject, Subject, Subscription, tap, throttleTime,} from 'rxjs';
import {first} from 'rxjs/operators';
import {TelegramService} from '../page-telegram/telegram.service';
import {environment} from '../../../environments/environment';
import {AllService} from '../../services/all.service';
import {
  Chat,
  Contact,
  IMessengerConnector,
  Message,
  MessageUser,
  Profile,
  ResultChatDetail,
  ResultHistory,
  SendMessage
} from '../../types/all.type';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {Router} from '@angular/router';
import {log} from '../../functions';
import {InterfaceService} from '../../services/interface.service';
import {Centrifuge, Subscription as CentrifugeSubscription} from "centrifuge";
import {AuthResponse} from "../../types/n8n.types";
import {DcService} from "../../services/dc.service";

interface N8nMessageRoot {
  id: number;
  session_id: string;
  message: N8nMessage;
}

interface N8nMessage {
  type: string;
  content: string;
  tool_calls: any[];
  additional_kwargs: Record<string, any>;
  response_metadata: Record<string, any>;
  invalid_tool_calls: any[];
}

@Injectable({
  providedIn: 'root'
})

export class FellowdeskService implements IMessengerConnector {
  public nemuAccounts: IMessengerConnector[] = [];
  public httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  public disabledMessageTextarea = false;
  public excludeDomains = ['messenger.teleseller.ru', 'leads.teleseller.ru'];
  status = true;
  environment = environment;
  public loadHistoryError: boolean | any = false;
  public type = 'fellowdesk';
  public name = 'TeleSeller';
  public unreadCount = 0;
  domain = 'fellow.realizeit.co';
  urlApi: any = 'https://n8n.teleseller.ru/webhook';
  urlApiFileUpload: any = 'https://n8n.teleseller.ru/webhook/ai-bot-upload';
  public arChat: Chat[] = [];
  public _openChat: Chat;
  public _openChatId: any;
  public arTyping: MessageUser[] = [];
  public arProfile: Profile = {} as Profile;
  public getProfile$: ReplaySubject<Profile> = new ReplaySubject();
  public setLocalHistory$: ReplaySubject<{
    id: string | number, arHistory: Message[]
  }> = new ReplaySubject();
  public arHistory: Message[] = [];
  public arLocalHistory: any = {};
  public replyMessage: Message | false = false;
  public forwardMessage: Message | false = false;
  public messageLastDate: number;
  public editMessage: Message | false = false;
  public bufferMessage = '';
  public message = '';
  public isLoadedProfile = false;
  public isLoadedProfileError = false;
  public reloadRequestsSubscription: Subscription;
  public token: string;
  public userId: string;
  public httpOptionsMulti: any = {
    headers: new HttpHeaders({
      // 'Content-Type':  'multipart/form-data',
    })
  };
  arVisibleStickers: any = [];
  public isDeleteAllMessage = false;
  public status$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private renderMessageBuffer: Message[] = [];
  private arProfilesCache: any = {};

  private centrifuge!: Centrifuge;
  private subscription!: CentrifugeSubscription;

  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    private router: Router,
    public notifierWrapService: NotifierWrapService,
    private allService: AllService,
    public telegramService: TelegramService,
    private http: HttpClient
  ) {
    ////
    // this.arLocalHistory = this.getVarLocal('history', {});
    if (this.arProfile) {
      this.isLoadedProfile = true;
    }
    this.setToken();
    this.connect();
    this.setLocalHistory$.pipe(throttleTime(3000)).subscribe((data) => {
      this.setLocalHistory(data.id, data.arHistory);
    });
    this.arProfile = this.getVarLocal('profile', {}) || {};
  }

  private connect() {
    this.centrifuge = new Centrifuge("wss://ws.teleseller.ru/connection/websocket", {
      token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIxMTc3NDE5MDAsImlhdCI6MTc1Nzc0MTkwMH0.3hDJrHAgG5bjqZJMZ7zw7duHm0zcbgVHe3b9jfWOXno"
    });

    this.centrifuge.on('connecting', (ctx) => {
      console.log('Connecting...', ctx);
    }).on('connected', (ctx) => {
      console.log('Connected:', ctx);
      this.allService.wsService.disconnect = false;
      this.allService.wsService.connection$.next(true);
    }).on('disconnected', (ctx) => {
      this.allService.wsService.disconnect = true;
      this.allService.wsService.disconnectedCount++;
      this.allService.wsService.connection$.next(false);
      console.log('Disconnected:', ctx);
    });

    this.subscription = this.centrifuge.newSubscription(`chat:${this.userId}`);

    this.subscription.on('publication', (ctx) => {
      console.log('New message:', ctx.data);

      const data = ctx.data;
      if (data.event === 'new_message') {
        const newMessage: Message = data.new_message;
        data.mute_until = this.readLocalNotify(newMessage?.from_user?.id || newMessage?.from_id)
      }
      this.allService.wsService.wsMessages$.next(data);
      // this.messages.push(ctx.data);
    }).on('subscribed', (ctx) => {
      console.log('Subscribed to channel');
    });

    this.centrifuge.connect();
    this.subscription.subscribe();
  }

  setToken(): void {
    this.token = localStorage.getItem(`${this.type}_token`);
    this.userId = localStorage.getItem(`${this.type}_user_id`);
    this.initToken();
  }

  initToken(): void {
    if (this.token) {
      this.httpOptions.headers = this.httpOptions.headers.set('X-User-Id', this.userId);
      this.httpOptions.headers = this.httpOptions.headers.set('X-Auth-Token', this.token);
      this.httpOptionsMulti.headers = this.httpOptionsMulti.headers.set('Authorization', 'Token ' + this.token);
    }
  }

  authorize(username: string, password: string): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.urlApi}/ai-bot-auth`, {
      login: username,
      password
    }).pipe(
      tap(data => {
        localStorage.setItem(this.type + '_token', new Date().getTime().toString());
        localStorage.setItem(this.type + '_user_id', data.id);
        this.setToken();
      })
    );
  }

  getUploadUrl(chatId, type = 'doc'): Observable<{ uploadUrl: string, method: 'post' | 'put' }> {
    return new Observable((observer) => {
      observer.next({uploadUrl: this.urlApiFileUpload, method: 'put'});
      observer.complete();
    });
  }

  addedFile(file: any): Observable<{ uploadUrl: string }> {
    return new Observable((observer) => {
    });

  }

  saveFile(file: File | Blob, title = '') {

    return new Observable((observer) => {
      observer.next(file);
      observer.complete();
    });
  }

  get isAuth(): boolean {
    return !!localStorage.getItem(this.type + '_token');
  }

  logout(onlyToken = true): void {
    console.warn('Rocket logout');
    localStorage.removeItem(this.type + '_token');
  }

  getVarLocal(name: string, defaultValue: any = {}) {
    try {
      return JSON.parse(localStorage.getItem(`${this.type}_` + name + '_' + this.token)) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  setVarLocal(name: string, val: any): void {
    const key = `${this.type}_` + name + '_' + this.token;
    try {
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {
      localStorage.removeItem(key);
      console.error('setVarLocal error', key);
    }
  }

  setLocalHistory(id, arHistory: Message[]): void {
    if (!id) {
      return;
    }
    this.arLocalHistory[id] = arHistory;
    // this.setVarLocal('history', this.arLocalHistory);
  }

  loadProfile(initiator = 'none'): Observable<any> {
    log('loadProfile', this.type, initiator);

    this.isLoadedProfileError = false;
    this.http.get(`${this.urlApi}/ai-bot-account`, this.httpOptions).pipe(throttleTime(3000)).subscribe(
      (result: any) => {
        this.isLoadedProfileError = false;
        this.arProfile = result;
        this.isLoadedProfile = true;
        this.setVarLocal('profile', this.arProfile);
        // console.log('Loaded profile getProfile')
        this.getProfile$.next(this.arProfile);

      },
      (error) => {
        this.getProfile$.error(error);
        this.isLoadedProfileError = error;
        this.interfaceService.errorHandling(error, true, this);
      }
    );
    // }
    return this.getProfile$;
  }

  getProfile(initiator = ''): Observable<Profile> {
    log('getProfile', this.type, initiator, this.arProfile);
    if (this.isLoadedProfile) {
      return new Observable((observer) => {
        setTimeout(() => {
          observer.next(this.arProfile);
          observer.complete();
        });
      });
    } else {
      return this.getProfile$;
    }
  }

  forwardMessages(chatId: any, fromChatId: any, messages: Message[]) {
    return new Observable((observer) => {
    }).pipe(first());
  }

  deleteMessages(chatId: any, revoke = true, messageIds: string[]) {
    return new Observable((observer) => {
    }).pipe(first());
  }

  saveMessage(arMessage: Message) {
    // TODO ответ удаляется
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    }).pipe(first());
  }

  sendMessage(arData: SendMessage): Observable<Message[]> {
    return this.http.post(`${this.urlApi}/ai-bot-send-manager-message`, arData, this.httpOptions) as any;

  }

  sendKeyBoard(arData: any) {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  mediaSearch(id, type = 'photo', limit = 15, timeout = 0) {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  getDetailInfo(id: any, media = true, membersCount = 0, freeAccount = false): Observable<ResultChatDetail> {
    return this.http.get(`${this.urlApi}/ai-bot-client-profile?sessionId=${id}&media=${media}&members_count=${membersCount}&service=${this.type}&free_account=${freeAccount}`, this.httpOptions) as any;
  }

  chatSearch(id: any, filter = '') {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  getChatSearch(id: any, filter = 'empty', query = '', offset = 0, limit = 15) {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  getGlobalSearch(query = '', limit = 15) {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  sendVoice(file, chat_id): Observable<Message[]> {
    return new Observable((observer) => {
      observer.next([] as any);
      observer.complete();
    });
  }

  getFile(fileId: string, fileUniqueId: string, ungzip = false) {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  // TODO
  getThumbSrc(attachment) {
    log('getThumbSrc');
  }

  getStickers() {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  getGifs() {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  deleteFile(uri: string) {
    // TODO Не безопасно!!!
    return this.http.delete(`${this.urlApiFileUpload}?uri=${uri}`);
  }

  setNotify(arData: any): Observable<any> {
    return new Observable((observer) => {
      const notifySettings = JSON.parse(localStorage.getItem('notify_settings') || "{}");
      notifySettings[arData.peer] = {mute_until: arData.mute_until};
      try {
        localStorage.setItem('notify_settings', JSON.stringify(notifySettings));
      } catch {
      }
      observer.next(notifySettings[arData.peer]);
      observer.complete();
    }).pipe(first());
  }

  readLocalNotify(peer: string | number) {
    const notifySettings = JSON.parse(localStorage.getItem('notify_settings') || "{}");
    if (notifySettings[peer]) {
      return notifySettings[peer];
    } else {
      return {mute_until: 0};
    }
  }

  getNotify(peer: string | number, chat: any = {}): Observable<any> {
    const subject = new Subject<any>();
    setTimeout(() => {
      subject.next(this.readLocalNotify(peer));
      subject.complete();
    });
    return subject;
  }

  toggleChatPine(id, pinned: boolean): Observable<void> {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    });
  }

  readHistory(chatId, maxId: string | number): Observable<any> {
    return this.http.post(
      `${this.urlApi}/ai-bot-read-message`,
      {
        chat_id: chatId,
        max_id: maxId,
        type: 'human'
      },
      this.httpOptions
    );
  }

  leaveChat(chat_id, del): Observable<void> {
    const subject = new Subject<any>();
    subject.complete();
    return subject;
  }

  contactsList(q = '', online: any = '', count = 100, timeout = 90): Observable<{ results: Chat[] | Contact[] }> {
    return this.http.get(
      this.urlApi + `/api/telegram/contacts?q=${q}&online=${online}&count=${count}&service=${this.type}`,
      this.httpOptions
    ) as any;
  }

  chatList(filterType = '', offsetDate = 0): Observable<{ results: Chat[] }> {
    return new Observable((observer) => {
      this.http.get(`${this.urlApi}/ai-bot-chats`, this.httpOptions).subscribe((res: any) => {
        console.log('--------------------', res)
        observer.next(res[0]);
        observer.complete();
      }, error => {
        observer.error(error);
        observer.complete();
      });
    });

  }

  chatNew(title = '', arUsers: any): Observable<any> {
    const subject = new Subject<any>();
    subject.next({});
    subject.complete();
    return subject;
  }


  getHistory(
    chatId: string,
    offset_id: string | number = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {}
  ): Observable<ResultHistory> {
    return new Observable((observer) => {
      this.http.get(`${this.urlApi}/ai-bot-history?limit=${limit}&currentCount=${currentCount}&ordering=-start_date&sessionId=${chatId}`, this.httpOptions)
        .subscribe((res: any) => {
          observer.next(res[0]);
        }, error => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  /*
   */
  getFileSrc(attachment: any) {
    attachment.file_uri = 'undefined';
    return attachment.file_uri;
  }

  loadAttachment$(attachment): Observable<any> {
    return new Observable((observer) => {
      observer.next({});
      observer.complete();
    });
  }

  getFile$(fileId: string, fileUniqueId = '', log = '') {
    return new Observable((observer) => {
      observer.next('');
      observer.complete();
    }).pipe(first()); // , tag("getFile$")
  }

  loadAudio$(attachment) {
    return new Observable((observer) => {
      observer.next(attachment);
      observer.complete();
    }).pipe(first()); // , tag("loadAudio$")
  }

  addChatUser(chat_id, user_id) {
    return new Observable((observer) => {
      observer.next();
      observer.complete();
    }).pipe(first());
  }

  errorHandling(error: any, isNotify = true) {
    log('errorHandling');
    log(error);
    if (isNotify) {
      this.notifierWrapService.notify('error', error?.error?.error_text || error?.error?.error_msg || error?.error_msg);
    }
  }

  set openChat(chat: Chat) {
    // this.renderMessageEditedBuffer = [];
    this._openChat = chat;
  }

  get openChat(): Chat {
    return this._openChat;
  }

  get openChatId() {
    return this._openChatId;
  }

  objectToParam(obj: any): string {
    const str =
      '?' +
      Object.keys(obj)
        .reduce((a, k) => {
          a.push(k + '=' + encodeURIComponent(obj[k]));
          return a;
        }, [])
        .join('&');
    return str;
  }

  setChatMode(sessionId: string | number, chatMode: string) {
    this.http.post<any>(`${this.urlApi}/ai-bot-profile-property`, {
      session_id: sessionId,
      ai_chat_mode: chatMode
    }, this.httpOptions).subscribe((v) => {
        const chat = this.allService.arChat.find((v: Chat) => v.id === sessionId);
        if (chat) {
          chat.ai_chat_mode = chatMode;
          this.allService.saveLocalChats$.next();
          this.dcService.detectChanges$.next('chat-list');
          this.dcService.detectChanges$.next('messages-scroll');
          this.dcService.detectChanges$.next('chat-show');

        }
      },
      error => {
        this.interfaceService.errorHandling(error);
      })
  }
}
